module.exports = __webpack_public_path__ + "img/C05TechAquiliferChampion_ua.65d010aa.webp";